var Backbone, EmailFormUSLocationSelectPaginationView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

EmailFormUSLocationSelectPaginationView = (function(superClass) {
  extend(EmailFormUSLocationSelectPaginationView, superClass);

  function EmailFormUSLocationSelectPaginationView() {
    return EmailFormUSLocationSelectPaginationView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSLocationSelectPaginationView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.element = this.options.paginationElement;
    this.itemsPerPage = this.options.itemsPerPage;
    this.totalNoOfItems = this.options.totalNoOfItems;
    return this.paginationClickHandler = this.options.callback;
  };

  EmailFormUSLocationSelectPaginationView.prototype.render = function() {
    return this.element.pagination(this.totalNoOfItems, {
      items_per_page: this.itemsPerPage,
      callback: this.paginationClickHandler,
      prev_text: I18n.t('js.modules.support.prev_text'),
      next_text: I18n.t('js.modules.support.next_text')
    });
  };

  EmailFormUSLocationSelectPaginationView.prototype.reRender = function() {
    this.element.empty();
    return this.render();
  };

  return EmailFormUSLocationSelectPaginationView;

})(Backbone.View);

module.exports = EmailFormUSLocationSelectPaginationView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9VUy9sb2NhdGlvbl9zZWxlY3RfcGFnaW5hdGlvbi5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9lbWFpbF9mb3JtL1VTL2xvY2F0aW9uX3NlbGVjdF9wYWdpbmF0aW9uLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLGlEQUFBO0VBQUE7OztBQUFBLFFBQUEsR0FBVyxPQUFBLENBQVEsVUFBUjs7QUFDWCxRQUFRLENBQUMsQ0FBVCxHQUFhOztBQUVQOzs7Ozs7O29EQUVKLFVBQUEsR0FBWSxTQUFDLE9BQUQ7SUFDVixJQUFDLENBQUEsT0FBRCxHQUFXLE9BQUEsSUFBVztJQUN0QixDQUFDLENBQUMsT0FBTyxDQUFDLEtBQVYsQ0FBZ0IsQ0FBaEIsRUFBbUIsQ0FBQyxJQUFELENBQU0sQ0FBQyxNQUFQLENBQWMsQ0FBQyxDQUFDLFNBQUYsQ0FBWSxJQUFaLENBQWQsQ0FBbkI7SUFDQSxJQUFDLENBQUEsU0FBRCxHQUFhO0lBQ2IsSUFBQyxDQUFBLE9BQUQsR0FBVyxJQUFDLENBQUEsT0FBTyxDQUFDO0lBQ3BCLElBQUMsQ0FBQSxZQUFELEdBQWdCLElBQUMsQ0FBQSxPQUFPLENBQUM7SUFDekIsSUFBQyxDQUFBLGNBQUQsR0FBa0IsSUFBQyxDQUFBLE9BQU8sQ0FBQztXQUMzQixJQUFDLENBQUEsc0JBQUQsR0FBMEIsSUFBQyxDQUFBLE9BQU8sQ0FBQztFQVB6Qjs7b0RBU1osTUFBQSxHQUFRLFNBQUE7V0FDTixJQUFDLENBQUEsT0FBTyxDQUFDLFVBQVQsQ0FBb0IsSUFBQyxDQUFBLGNBQXJCLEVBQ0U7TUFBQSxjQUFBLEVBQWUsSUFBQyxDQUFBLFlBQWhCO01BQ0EsUUFBQSxFQUFTLElBQUMsQ0FBQSxzQkFEVjtNQUVBLFNBQUEsRUFBWSxJQUFJLENBQUMsQ0FBTCxDQUFPLDhCQUFQLENBRlo7TUFHQSxTQUFBLEVBQVksSUFBSSxDQUFDLENBQUwsQ0FBTyw4QkFBUCxDQUhaO0tBREY7RUFETTs7b0RBT1IsUUFBQSxHQUFVLFNBQUE7SUFDUixJQUFDLENBQUEsT0FBTyxDQUFDLEtBQVQsQ0FBQTtXQUNBLElBQUMsQ0FBQSxNQUFELENBQUE7RUFGUTs7OztHQWxCMEMsUUFBUSxDQUFDOztBQXNCL0QsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
